module.exports = __webpack_public_path__ + "img/far_night_cyl75_axis90.7e99f30c.jpg";